module.exports = __webpack_public_path__ + "img/ctrl-s-dagger-stub-+i.ffa4f9b1.svg";